export const FRESH_PACK_RULES = {"50620708094177": {"min": 6, "max": 12}, "50620708126945": {"min": 3, "max": 6}, "50620708684001": {"min": 6, "max": 12}, "50620708716769": {"min": 3, "max": 6}, "50620709044449": {"min": 6, "max": 12}, "50620709077217": {"min": 3, "max": 6}, "50620709372129": {"min": 6, "max": 12}, "50620709404897": {"min": 3, "max": 6}, "50620709699809": {"min": 6, "max": 12}, "50620709732577": {"min": 3, "max": 6}, "50620710093025": {"min": 6, "max": 12}, "50620710125793": {"min": 3, "max": 6}, "50620711043297": {"min": 6, "max": 12}, "50620711076065": {"min": 3, "max": 6}, "50620711993569": {"min": 6, "max": 12}, "50620712026337": {"min": 3, "max": 6}, "50620712386785": {"min": 6, "max": 12}, "50620712419553": {"min": 3, "max": 6}, "50544348823777": {"min": 6, "max": 12}, "50544357671137": {"min": 6, "max": 12}, "50544359669985": {"min": 6, "max": 12}, "50620775891169": {"min": 6, "max": 12}, "50545612226785": {"min": 6, "max": 12}, "50545612259553": {"min": 3, "max": 6}};

export function freshPackViolations(cart, rules = FRESH_PACK_RULES) {
  const totals = new Map();
  for (const item of cart.items || []) {
    const id = String(item.variant_id ?? item.id);
    if (!rules[id]) continue;
    const current = totals.get(id) || { title: item.product_title || item.title || 'Fresh meal', quantity: 0, ...rules[id] };
    current.quantity += Number(item.quantity);
    totals.set(id, current);
  }
  return [...totals.values()].filter(item => !Number.isInteger(item.quantity) || (item.quantity !== item.min && item.quantity !== item.max));
}

if (typeof document !== 'undefined') {
  let checking = false;
  let quantityChangedAt = 0;
  const root = window.Shopify?.routes?.root || '/';
  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

  const showError = message => {
    let alert = document.querySelector('[data-hp-checkout-pack-alert]');
    if (!alert) {
      alert = document.createElement('p');
      alert.dataset.hpCheckoutPackAlert = '';
      alert.setAttribute('role', 'alert');
      alert.tabIndex = -1;
      const host = document.querySelector('.cart__ctas') || document.querySelector('main') || document.body;
      host.prepend(alert);
    }
    alert.textContent = message;
    alert.focus();
  };

  document.addEventListener('quantity-selector:update', () => { quantityChangedAt = Date.now(); }, true);

  const validateBeforeCheckout = async (skipUpsell = false) => {
    if (checking) return;
    checking = true;
    try {
      // Cart quantity changes are debounced; wait for their pending request before reading the cart.
      const deadline = Date.now() + 10000;
      while (Date.now() - quantityChangedAt < 400 || document.querySelector('.cart-items-disabled, cart-note[data-saving]')) {
        if (Date.now() > deadline) throw new Error('Please wait for your cart update, then try checkout again.');
        await pause(50);
      }
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('We could not check your cart. Please try checkout again.');
      const cart = await response.json();
      const consultationCount = (cart.items || []).filter(item => item.handle === 'online-vet-consultation').reduce((sum, item) => sum + Number(item.quantity), 0);
      if (consultationCount > 1) {
        showError('Only one vet consultation can be purchased at a time. Remove the extra consultations before checking out.');
        return;
      }
      const errors = freshPackViolations(cart);
      if (errors.length) {
        const message = errors.map(item => `${item.title}: choose ${item.min} or ${item.max} packs (currently ${item.quantity}).`).join(' ');
        if (!document.querySelector('[data-hp-fresh-cart-errors]')) showError(message);
        if (!document.querySelector('cart-items-component')) window.location.assign(`${root}cart`);
        return;
      }
      if (!skipUpsell && window.hpCheckoutUpsell) {
        const decision = await window.hpCheckoutUpsell.offer(cart, { trigger: 'checkout' });
        if (decision !== 'continue') return;
        checking = false;
        await validateBeforeCheckout(true);
        return;
      }
      window.location.assign(`${root}checkout`);
    } catch (error) {
      showError(error.message || 'We could not check your cart. Please try again.');
    } finally {
      checking = false;
    }
  };

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
    if (!target) return;
    if (target instanceof HTMLAnchorElement) {
      const url = new URL(target.href, window.location.href);
      if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
    }
    if (target.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void validateBeforeCheckout();
  }, true);

  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    void validateBeforeCheckout();
  }, true);
  window.hpCheckoutGuard = { checkout: (options = {}) => validateBeforeCheckout(options.skipOffers === true) };
}
